module.exports = "<div class=\"piechart\">\r\n  <canvas #chart id=\"pieCanvas{{ review.Id }}\"></canvas>\r\n  <span>64 total</span>\r\n</div>\r\n"